module.exports = __webpack_public_path__ + "static/img/lucky-bag.75c49038.png";